import { useEffect } from "react";
import { usePython } from "react-py";
import "./NamingLoop.css";

function NamingLoop() {
    const { runPython, stdout } = usePython();

    useEffect(() => {
        runPython(`

                    name = "Explorelrt"
                    size = len(name)


                    for i in range(1, size+1):
                        print(" " * (size + i) + name[:i])

                    for i in range(0, size + 1):
                        print(" " * (size) + name[i:])


                    for i in range(size, 0, -1):
                        print(" " * (size-i) + name[:i])


                `);
    }, [runPython]);

    return (
        <div className="loopContainer">
            <pre className="loopOutput">{stdout}</pre>
        </div>
    );
}

export default NamingLoop;
